export const setConsentVersionBasedOnModel = (
  initialVersion: string | undefined, // consent version cookie value when the model is loaded (utiqLoader is loaded)
  currentVersion: number | undefined, // consent version from template data
  previousVersion: number | undefined, // previous consent version from template data
  currentConsentStatusCookie: string,
) => {
  const isIntegratedConsentModel = window.Utiq?.config?.CMP;
  const preventEarlyConsentRefresh =
    window.Utiq?.config?.getNewConsentBeforeExpiry === false &&
    currentConsentStatusCookie;

  const isUtiqPassStoredOrNotEligible =
    localStorage.getItem('utiqPass') ||
    window.Utiq?.initialEligibilityValue === false;

  if (
    initialVersion === '' &&
    (isIntegratedConsentModel || preventEarlyConsentRefresh) &&
    isUtiqPassStoredOrNotEligible
  ) {
    if (window.Utiq?.initialEligibilityValue === false) {
      window.Utiq.initialEligibilityValue = undefined;
    } else if (
      !window.Utiq!.initialConsentStatusCookieValue ||
      localStorage.getItem('utiqPass')
    ) {
      return previousVersion;
    }
  }

  return currentVersion;
};
